module.exports = __webpack_public_path__ + "644d1630505e06ac9d7a9bd328cfce11.png";